import { SearchOutlined } from '@ant-design/icons';
import { Select, Space } from 'antd';
import DateRangePickerField from 'components/Global/DateRangePicker';
import SearchComponent from 'components/Global/SearchComponent';
import styles from './index.module.scss';

type Props = {
	searchText: string;
	handleSearch: (value: string) => void;
	handleSearchApi: (value: string) => void;
	StatusFilter: any;
	handleStatusFilter: (value: string) => void;
	handleDatePicker: any;
	dateValue: any;
};

const LeaveRequestHeader = (props: Props) => {
	const {
		searchText,
		handleSearch,
		handleSearchApi,
		StatusFilter,
		handleStatusFilter,
		handleDatePicker,
		dateValue,
	} = props;
	
	return (
		<div className={styles['employee-header']}>
			<Space>
				<SearchComponent
					className={styles['employee-header-item']}
					placeHolder="Search Name | Code | Reason"
					prefixIcon={<SearchOutlined />}
					handleChange={handleSearch}
					handleChangeApi={handleSearchApi}
					value={searchText}
					size="large"
				/>
				<Space>
					<DateRangePickerField
						className={styles['employee-header-item']}
						name={'dateFilter'}
						value={dateValue}
						required={false}
						isError={false}
						onChange={handleDatePicker}
					/>
				</Space>

				<Select
					style={{ width: 200 }}
					className={styles['employee-header-item']}
					value={StatusFilter}
					options={[
						{
							value: '',
							label: 'All Status',
						},
						{
							value: 'PENDING',
							label: 'Pending',
						},
						{
							value: 'APPROVED',
							label: 'Approved',
						},
						{
							value: 'REJECTED',
							label: 'Rejected',
						},
					]}
					onChange={(value) => handleStatusFilter(value)}
					size="large"
					placeholder="Select Status"
				/>
			</Space>
		
		</div>
	);
};

export default LeaveRequestHeader;
